import React, { useState } from 'react'
import Checkbox from '../../elements/form/Checkbox'
import ModalActionButton from '../../elements/ModalActionButton'
import TextareaField from '../../elements/form/TextareaField'
import { useDispatch } from 'react-redux'
import { ERROR, SET_SUCCESS } from '../../../store/types'
import { authHeader } from '../../../utils'
import axios from 'axios'
import TextField from '../../elements/form/TextField'

const StudentCheckOut = ({exeat, close, reload}) => {
    const dispatch = useDispatch()
    const [processing, setProcessing] = useState(false)
    const [confirmed, setConfirmed] = useState(false)
    const [validationErrors, setValidationErrors] = useState({})
    const [note, setNote] = useState('')
    const [pickupCode, setPickupCode] = useState('')

    const completeCheckIn = async () => {
      if (!confirmed) {
          setValidationErrors({confirmation: true})
          dispatch({
              type: ERROR,
              error: {response: {data: {
                  message: 'Please confirm that the student has been properly checked'
              }}}
          });
          return
      }
      try {
          const payload = {
              pickupCode,
              note
          }

          const headers = authHeader()

          setProcessing(true)
          await axios.post(`${process.env.REACT_APP_BASE_URL}/check-outs`, payload, { headers })
          dispatch({
              type: SET_SUCCESS,
              payload: 'Student Checked-out successfully!'
          })
          reload()
          setProcessing(false)
          close()
      } catch (error) {
          console.error('error checking out: ', error)
          dispatch({
              type: ERROR,
              error
          })
          setProcessing(false)
      }
  }
  return (
    <div className='w-full'>
      <p className='text-sm text-gray-600'>By clicking the "Check-Out" button below, you confirm that the student has been checked and that they are not carrying any contraband out of the school premises.</p>

      <div className='my-2 w-full'>
        <TextField
          inputLabel="Pick-up code" 
          fieldId="pickup-code" 
          inputType="text" 
          requiredField={false}
          inputPlaceholder="Please provide pick-up code"
          preloadValue={note || ''}
          hasError={false} 
          returnFieldValue={(value)=>{setPickupCode(value)}}
        />
      </div>

      <div className='my-2 w-full'>
        <TextareaField
          inputLabel="Check-out note" 
          fieldId="check-out-note" 
          inputType="text" 
          requiredField={false}
          inputPlaceholder="You can add a note if necessary"
          preloadValue={note || ''}
          hasError={false} 
          returnFieldValue={(value)=>{setNote(value)}}
        />
      </div>
      
      <div className='mt-4'>
        <div className='w-full my-2'>
          <Checkbox
            CheckboxLabel="I confirm that the student has been properly checked"
            checkboxToggleFunction={()=>{
                setConfirmed(!confirmed)
            }} 
            isChecked={confirmed} 
            hasError={validationErrors && validationErrors.confirmation} 
          />
        </div>
      </div>
      <div className="mt-8 flex flex-row-reverse gap-x-4">
        <ModalActionButton
          buttonLabel={`Check-out Student on Exeat`}
          buttonAction={()=>{completeCheckIn()}}
          processing={processing}
        />

        <button
          type="button"
          className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-md hover:bg-opacity-50 hover:bg-secondary focus:outline-none"
          onClick={()=>{close()}}
        >
          Cancel
        </button>
      </div>
    </div>
  )
}

export default StudentCheckOut